import { render, staticRenderFns } from "./AddToNextDeliveryModal.vue?vue&type=template&id=1abf48d6&"
import script from "./AddToNextDeliveryModal.vue?vue&type=script&lang=js&"
export * from "./AddToNextDeliveryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports